<!-- TEMPLATE -->
<template>
  <dean-dialog
          class="graph"
          title="Maandelijkse orders"
          :icon="invoiceDetailsIcon"
          align-top>
    <div class="">
      <pie-chart :library="legend" :data="data" :donut="true" :colors="['#b6b6b7', '#00839b', '#dd1b16']"></pie-chart>
    </div>
    <transition name="fade" mode="out-in" v-if="isLoading">
      <dean-load-overlay></dean-load-overlay>
    </transition>
  </dean-dialog>
</template>
<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import { Component, Prop, Watch } from 'vue-property-decorator';

  // DEAN COMPONENTS
  import {
    invoiceDetailsIcon,
    groupIcon,
    deanDialog,
    deanButton,
    deanLoadOverlay,
  } from '@deanone/dean-components';
  import Chartkick from 'vue-chartkick';
  import Chart from 'chart.js';
  import axios from 'axios';

  Vue.use(Chartkick.use(Chart));

  @Component({
    components: {
      deanLoadOverlay,
      Chartkick,
      Chart,
      invoiceDetailsIcon,
      groupIcon,
      deanDialog,
      deanButton,
    },
  })

  export default class MonthlyOrdersGraph extends Vue {
    public invoiceDetailsIcon: object = invoiceDetailsIcon;
    public groupIcon: object = groupIcon;
    public legend: object = {
      legend: {
        labels: {
          pointStyle: 'circle',
          fontSize: 12,
          boxWidth: 12,
          usePointStyle: true,
        },
      },
    };
    public data: object = {};
    public header: string = '';
    public subHeader: string = '';
    public isLoading: boolean = true;

    public mounted() {
      axios
        .post('/-/trade/api/widgets.monthlyOrdersGraph')
        .then(({data}) => {
          Vue.set(this.data, 'offertes', data.quotes);
          Vue.set(this.data, 'orders', data.orders);
          Vue.set(this.data, 'verloren', data.quotesLost);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
</script>
<!-- STYLE -->
<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  .dialog :deep {
    padding: 0;
  }

  .dialog :deep(.dean-dialog-container) {
    width: 100%;
    height: 100%;
  }

  .dialog :deep(.dean-dialog-container .dean-dialog-content) {
    height: 100%;
  }
</style>
